import { render, staticRenderFns } from "./LoyalitySettings.vue?vue&type=template&id=7d053100&scoped=true"
import script from "./LoyalitySettings.vue?vue&type=script&lang=js"
export * from "./LoyalitySettings.vue?vue&type=script&lang=js"
import style0 from "./LoyalitySettings.vue?vue&type=style&index=0&id=7d053100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d053100",
  null
  
)

export default component.exports